import { Add, ErrorOutline } from "@mui/icons-material";
import { Alert, Box, Button, CircularProgress } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AllSetUpModal from "../modals/AllSetUpModal";
import planData from '../plans.json';
import { jwtDecode } from "jwt-decode";
import decryptApi from "../utils/decryptApi";

const CallRoutings = () => {
  const location = useLocation();
  const navigate = useNavigate()
  const [openAllSetUpModal, setOpenAllSetupModal] = useState(false);


  const [planDetails, setPlanDetails] = useState(null);
  const check_subscription = async () => {
    try {
      setLoader(true)
      let sub = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
        {
          customer_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_cust_id.S,
          sub_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_sub.S,
        }
      );

      // console.log(sub.data)

      // console.log(planData[sub.data?.planDetails[0].plan_id])
      setPlanDetails(planData[sub.data?.planDetails[0].plan_id])
      return;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
 };
 useEffect(() => {
  check_subscription()
}, [])



  const [loader, setLoader] = useState(true);
  const [error_msg, setErrorMsg] = useState(null);
  const [routes, setRoutes] = useState(null);

  const getRoutes = async () => {
    try {
      let routes = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "route/get-routes",
        { org_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
      );

      // console.log(routes);

      setRoutes(routes.data.routes);
      setLoader(false)
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  // const getCalls = async (route_id) => {
   
  //   try {
  //     let calls = await axios.post(
  //       process.env.REACT_APP_BACKEND_URL + "call/get-calls-by-route",
  //       { route_id, organization_id : JSON.parse(localStorage.getItem("organization")).orgId.S  }
  //     );

  //     setLoader(false);
  //     console.log('jo')
  //     console.log(calls)
  //     function filterCallsLast30Days() {
  //       const now = Date.now();
  //       const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
      
  //       return  calls.data.calls.filter(call => {
  //         const timestamp = parseInt(call.startTime.N, 10); // Convert N field to a number
  //         return timestamp >= thirtyDaysAgo && timestamp <= now;
  //       });
  //     }
  //     console.log('ejwe',filterCallsLast30Days())
      
  //     let recentCalls = filterCallsLast30Days();
  //     console.log('recent_calls', recentCalls)
  //     return recentCalls;
  //   } catch (error) {
  //     console.log(error);
  //     if (error.response && error.response.data) {
  //       console.error("Response data:", error.response.data);
  //       setErrorMsg(error.response.data.message);
  //     }
  //     setLoader(false);
  //   }
    
  // };
  const [callsData, setCallsData] = useState({});

  useEffect(() => {
    getRoutes();
  }, []);

  useEffect(() => {
  //   const fetchCalls = async () => {
  //     let data = {};
  //     for (const route of routes) {
  //       const calls = await getCalls(route.routeId.S); // Assuming getCalls returns the calls
      
  //       data[route.routeId.S] = calls?.length; // Store the length of calls for each route
  //     }
  //     console.log('data',data)
  //     setCallsData(data);
  //   };

  //  if(routes){
  //   fetchCalls();
  //  }
  }, [routes]);





  return (
    <div className="pt-7 px-4 w-full ">
     
    
      <div className="lg:text-[17px] text-[15px] flex justify-between font-semibold mb-4 w-full">
       <div> Call Routing</div>
        {loader && (
        <div className="flex justify-center pr-2">
          <CircularProgress size={"1.2rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
        </div>
      )} 
      </div>

      {error_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
          <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
        </div>
      )}

      
      <div className="space-y-8 w-full">
        {routes &&
          routes.length > 0 ?
          routes.map((route, index) => 
            
            
            {
              //get phone numbers
              let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
              .M;


              const getPhoneNumber = async () => {
                try {
                  let phoneNumber_ = await axios.post(
                    process.env.REACT_APP_BACKEND_URL + "twilio/get-phone-number",
                    {  account_sid: t.account_sid.S,
                      api_key: (t.api_key.S),
                      phone_number: route.configured_phone.S,
                     }
                  );

                  // console.log(phoneNumber_.data.voiceUrl)
                  if(phoneNumber_.data.voiceUrl === 'https://incoming.twilanswer.com/'+route.routeId.S){
                    // console.log('yes')
                    document.getElementById('connected-'+index).innerHTML = 'Connected'
                    document.getElementById('disconnected-'+index).hidden = true
                    document.getElementById('connected-'+index).hidden = false
                    document.getElementById('loader-'+index).hidden = true
                  }else{
                     document.getElementById('disconnected-'+index).innerHTML = 'Disconnected'
                     document.getElementById('connected-'+index).hidden = true
                     document.getElementById('disconnected-'+index).hidden = false
                     document.getElementById('loader-'+index).hidden = true
                     
                  }
            
                 
                } catch (error) {
                  console.log(error);
                  if (error.response && error.response.data) {
                    console.error("Response data:", error.response.data);
                    setErrorMsg(error.response.data.message);
                    document.getElementById('disconnected-'+index).innerHTML = 'Disconnected'
                     document.getElementById('connected-'+index).hidden = true
                     document.getElementById('disconnected-'+index).hidden = false
                     document.getElementById('loader-'+index).hidden = true
                  }
                }
              };

              getPhoneNumber()


            //  const getCallsByRoute = async()=> {
            //   let calls = await axios.post(
            //     process.env.REACT_APP_BACKEND_URL + "call/get-calls-by-route",
            //     {route_id: route.routeId.S, organization_id : JSON.parse(localStorage.getItem("organization")).orgId.S  }
            //   );


            //     const now = Date.now();
            //     const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
              
            //     let rc =  calls.data.calls.filter(call => {
            //       const timestamp = parseInt(call.startTime.N, 10); // Convert N field to a number
            //       return timestamp >= thirtyDaysAgo && timestamp <= now;
            //     });
            //   console.log('ejwe',rc)
              
            //     if( document.getElementById('rc-'+index)){
            //       document.getElementById('rc-'+index).innerHTML = rc.length

            //     }
              
            //  }

            //  getCallsByRoute()
            return (
              <div className="space-y-8 w-full">
                <div className="bg-white px-7 py-8 rounded-[20px] flex lg:items-center items-start w-full">
                  <div className="lg:flex lg:space-x-3 space-y-3 lg:space-y-0 flex-1 items-center w-full">
                    <div className="text-[16px] lg:text-[14px] font-semibold">
                     {route.name.S}
                    </div>

                    <div className="bg-[#FAFAFB]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]">
                     {route.configured_phone.S}

                   
                    </div>


                    <div id={'loader-'+index}>
                     <CircularProgress size={"1rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
                      </div>

                        <div hidden={true} id={'connected-'+index} className="bg-[rgba(0,186,37,0.1)] text-[#3A974C]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]">
                        <CircularProgress size={"1rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
                    </div>

                    <div hidden={true} id={'disconnected-'+index} className="bg-[rgba(242,147,57,0.1)] text-[#F29339]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]">
                        <CircularProgress size={"1rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />
                    </div>

                    {/* <div 
                    onClick={()=> {
                      navigate('/dashboard')
                    }}
                    className="cursor-pointer bg-[rgba(96,91,255,0.1)] rounded-[15px] lg:w-[190px] w-[100%] justify-center py-2 text-[#605BFF] flex items-center text-[12px] lg:text-[13px] font-semibold">
                      <img
                        src="/icons/phone_purple.png"
                        className="w-[20px] mr-2"
                      />{" "}
                      <span id={'rc-'+index} className='mr-[2px]'>  </span>{"  "}  Calls Last 30 Days
                    </div> */}
                  </div>

                  <div className="text-[12px] lg:text-[13px] text-[#605BFF] font-semibold cursor-pointer hover:underline"
                  onClick={()=> {
                    navigate('/dashboard/call-route/'+route.routeId.S)
                  }}
                  >
                    Edit
                  </div>
                </div>
              </div>
            );
          }) : (
            <>
           
            </>
           
          )}

        {/* <div className="bg-[rgba(242,147,57,0.1)] text-[#F29339]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]">
              Inactive
            </div> */}

        {routes?.length >= planDetails?.inbound_numbers  ? (
          <div className="px-4 lg:px-0">
          <div className="text-center text-[16px] lg:text-[18px] font-semibold mb-2 mt-4">
           Upgrade Plan
          </div>
          <div className="text-center text-[12px] lg:text-[14px]  mb-4">
          You have used all the routes allowed by your plan. To add more, please upgrade
          </div>

          <div className="flex justify-center">
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#605BFF",
                color: "white",
                py: "10px",
                px: "20px",
                borderRadius: "12px",
                fontSize: { lg: "14px", xs: "12px" },
              }}
              onClick={()=> {
                navigate('/dashboard/settings/billing')
              }}
            >
              <Add sx={{ fontSize: "20px", position: "relative", bottom: 1 }} />
              Upgrade
            </Button>
          </div>
        </div>
        ): (<>
        {routes ? (
          
            <div className="px-4 lg:px-0">
            <div className="text-center text-[16px] lg:text-[18px] font-semibold mb-2 mt-4">
              Want to manage multiple numbers dynamically?
            </div>
            <div className="text-center text-[12px] lg:text-[14px]  mb-4">
              Create additional routes to setup custom routing for each number.
            </div>
  
            <div className="flex justify-center">
              <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "#605BFF",
                  color: "white",
                  py: "10px",
                  px: "20px",
                  borderRadius: "12px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                disabled={loader}
                onClick={()=> {
                  navigate('/dashboard/create-route')
                }}
              >
                <Add sx={{ fontSize: "20px", position: "relative", bottom: 1 }} />
                Add Route
              </Button>
            </div>
          </div>
          
        ): (
          <div className="px-4 lg:px-0">
          <div className="text-center text-[16px] lg:text-[18px] font-semibold mb-2 mt-4">
           You do not have any routes created yet.
          </div>
          <div className="text-center text-[12px] lg:text-[14px]  mb-4">
          Click the "Add Route" button to create one. Need help? <a className="hover:underline hover:text-blue-600 cursor-pointer" href={'mailto:hello@twilanswer.com'} >Contact Support</a>.
          </div>

          <div className="flex justify-center">
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#605BFF",
                color: "white",
                py: "10px",
                px: "20px",
                borderRadius: "12px",
                fontSize: { lg: "14px", xs: "12px" },
              }}
              disabled={loader}
              onClick={()=> {
                navigate('/dashboard/create-route')
              }}
            >
              <Add sx={{ fontSize: "20px", position: "relative", bottom: 1 }} />
              Add Route
            </Button>
          </div>
        </div>
        )}
        </>)}
      </div>
    </div>
  );
};

export default CallRoutings;
